import { ObjectTypeWkf } from '../ObjectTypeWkf';

export class WorkflowModelInfos {
  constructor( public key: string, public label: string, public bulkActions?:string[], public unassignable?:boolean) {}

  public static getInitStore(): { -readonly [searchTypeKey in ObjectTypeWkf]?: WorkflowModelInfos[] } {
    return  {
      PROCESSUS : [],
      TASK : [],
    }
  }
}
